export { default as PriceChanges } from './PriceChanges';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/PriceChanges/index.ts